module.exports = __webpack_public_path__ + "static/media/img4.4131d8fb.jpg";